import { render, staticRenderFns } from "./ImportPanel.vue?vue&type=template&id=4b8f6c8e"
import script from "./ImportPanel.vue?vue&type=script&lang=js"
export * from "./ImportPanel.vue?vue&type=script&lang=js"
import style0 from "./ImportPanel.vue?vue&type=style&index=0&id=4b8f6c8e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports